import storage from './storage';

const KEY = 'crm_call_scripts';

const DEFAULT_SCRIPTS = [
  {
    id: 'generic',
    label: 'Standard-Skript',
    branch: '',
    text: `Guten Tag, mein Name ist [Name] von [Firma].

Ich rufe an, weil wir Unternehmen wie {{firma}} dabei helfen, [Nutzen].

Darf ich kurz fragen: Wie handhaben Sie aktuell [Thema]?

→ Bei Interesse: Termin vorschlagen
→ Kein Bedarf: Rückruf in X Wochen?`,
  },
];

export const callScriptService = {
  getAll() {
    try {
      const saved = storage.get(KEY, null);
      if (!saved || !Array.isArray(saved)) return DEFAULT_SCRIPTS;
      return saved;
    } catch { return DEFAULT_SCRIPTS; }
  },

  saveAll(scripts) {
    storage.set(KEY, scripts);
  },

  getForBranch(branch) {
    const all = this.getAll();
    if (branch) {
      const match = all.find(s => s.branch && s.branch.toLowerCase() === (branch || '').toLowerCase());
      if (match) return match;
    }
    return all.find(s => !s.branch) || all[0] || null;
  },
};
